// extracted by mini-css-extract-plugin
module.exports = {"suggests":"e462cbfa4b--suggests--iMoQs","suggest":"e462cbfa4b--suggest--JYr4E","suggest--active":"e462cbfa4b--suggest--active--AJKC6"};